// Update price when variant changes
document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const card = select.closest('.uviator-sibling-card');
  const priceDisplay = card.querySelector('[data-price-display]');
  const selectedOption = select.options[select.selectedIndex];

  if (priceDisplay && selectedOption.dataset.price) {
    priceDisplay.textContent = selectedOption.dataset.price;
  }
});

// Handle add to cart
document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-add-to-cart]');
  if (!button) return;

  const card = button.closest('.uviator-sibling-card');
  const select = card.querySelector('[data-variant-select]');
  const widget = button.closest('.uviator-siblings');

  const variantId = select ? select.value : null;
  if (!variantId) return;

  const sourceProductTitle = widget?.dataset.sourceProductTitle || 'Unknown Product';

  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: {
          '_Added from': 'UViator cross-sell widget',
          '_Source product': sourceProductTitle,
          '_Source product ID': widget?.dataset.sourceProductId || 'Unknown'
        }
      })
    });

    if (!response.ok) {
      throw new Error('Add to cart failed');
    }

    const data = await response.json();

    // Update UI
    button.textContent = 'Added';

    // Trigger theme cart updates (for drawer/cart refresh)
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    // Push analytics event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'uviator_cross_sell_add_to_cart',
      variant_id: variantId,
      source_product: sourceProductTitle
    });

  } catch (error) {
    console.error(error);
    button.textContent = 'Error';
  }

  setTimeout(function () {
    button.textContent = originalText;
    button.disabled = false;
  }, 1200);
});